import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import flowRight from 'lodash/flowRight';

import RootField from './RootField';
import * as CRUDActions from '../../actions/EntityCRUD';

class RootForm extends React.Component {
  componentDidMount() {
    if (!this.props.provideController) { return; }
    this.props.provideController({
      save: () => this.save(),
      create: () => this.create(),
      isInvalid: () => this.isInvalid(),
      isDirty: () => this.isDirty(),
      submitForm: () => this.submitForm(),
      handleSubmit: f => this.props.handleSubmit(f),
    });
  }

  componentWillUnmount() {
    if (!this.props.provideController) { return; }
    this.props.provideController(null);
  }

  isInvalid = () => this.props.invalid;
  isDirty = () => this.props.dirty;

  save = () => {
    if (this.isInvalid()) { return; }
    const {
      dispatch, dataFetch, formData, formName, entityName,
    } = this.props;
    dispatch(CRUDActions.save(entityName || formName, formData.values, dataFetch));
  }

  create = () => {
    if (this.isInvalid()) { return; }
    const {
      dispatch, dataFetch, formData, formName, entityName,
    } = this.props;
    dispatch(CRUDActions.create(entityName || formName, formData.values, dataFetch));
  }

  submitForm = () => this.form.submit();

  render() {
    const {
      fields, lookups, token, dispatch, formName, formData,
    } = this.props;

    return (
      <form ref={(form) => { this.form = form; }}>
        {fields.map((f, i) =>
          (<RootField
            key={i}
            {...f}
            token={token}
            lookupValue={f.lookup ? lookups[f.lookup.lookupValue] : ''}
            linkValue={f.link ? lookups[f.link.linkValue] : ''}
            dispatch={dispatch}
            formName={formName}
            formData={formData}
          />))}
      </form>
    );
  }
}

RootForm.defaultProps = {
  formData: {},
  lookups: {},
  entityName: '',
  dataFetch: () => null,
};

RootForm.propTypes = {
  fields: PropTypes.array.isRequired,
  formData: PropTypes.object,
  lookups: PropTypes.object,
  token: PropTypes.string.isRequired,
  provideController: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  dataFetch: PropTypes.func,
  formName: PropTypes.string.isRequired,
  entityName: PropTypes.string,
  invalid: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func,
};

// Handle variable names for the redux-form
export default flowRight(connect((state, props) => {
  const selector = formValueSelector(props.formName);
  return {
    form: props.formName,
    formData: state.form[props.formName],
    validate: props.validate,
    initialValues: props.initialValues,
    lookups: selector(state, ...new Set([...props.fields.filter(f => f.lookup).map(l => l.lookup.lookupValue), ...props.fields.filter(f => f.link).map(l => l.link.linkValue)]), 'forceObject'),
    token: state.loginReducer.user.token,
  };
}), reduxForm({}))(RootForm);



// WEBPACK FOOTER //
// ./src/components/form/RootForm.js